<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" width="500px" maxWidth="500px">
            <template v-slot:activator="{ on, attrs }">
                <p v-bind="attrs"
                   v-on="on"
                   class="login-register-forgot-password" v-html="$th('login-register-account.reset-password.forgot-password')"></p>
            </template>

            <v-card flat class="disable-select">
                <dragger class="mr-4"></dragger>
                <v-card-title class="text-break"><span v-html="$th('login-register-account.reset-password.text')"></span></v-card-title>
                <v-form v-model="valid" ref="r_form_reset_password">

                    <v-layout class="text-center mx-10">
                        <v-text-field
                                v-model="email"
                                append-icon="mdi-magnify"
                                :label="$t('login-register-account.reset-password.email')"
                                :color="$variables.v.theme.secondary"
                                :rules="[rules.required, rules.no_white_spaces, rules.valid_email, rules.max150]"
                                maxlength="200"
                                class="default-textfield-width"></v-text-field>
                        <v-text-field
                                v-model="username"
                                append-icon="mdi-magnify"
                                :label="$t('login-register-account.reset-password.username')"
                                :color="$variables.v.theme.secondary"
                                :rules="[rules.required, rules.min3, rules.max30, rules.no_white_spaces]"
                                maxlength="30"
                                class="default-textfield-width"></v-text-field>
                    </v-layout>


                    <v-col class="text-center">
                        <!--Hide captcha when it is disabled-->
                        <vue-hcaptcha v-if="$variables.v.enable_hcaptcha"
                                      :key="unlock_captcha"
                                      :sitekey="$variables.v.hcaptcha_sitekey"
                                      @verify="on_captcha_verified"
                                      @expired="reset_captcha_state"
                                      @error="reset_captcha_state"
                                      theme="dark"></vue-hcaptcha>

                        <v-btn :disabled="!valid || ($variables.v.enable_hcaptcha && !captcha_success)"
                               color="success"
                               depressed
                               :key="unlock_request_password"
                               @click.once="request_new_password">
                            <span v-html="$th('login-register-account.reset-password.request-new-password')"></span>
                        </v-btn>
                    </v-col>
                </v-form>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default {
        data() {
            return {
                dialog: false,
                valid : false,

                email   : "",
                username: "",

                captcha_success        : false,
                captcha_token          : "", // Token of the solved captcha, the server verifies it
                unlock_captcha         : 0,
                unlock_request_password: 100000,
                rules                  : {
                    required       : v => (!!v) || this.$t("rules.required"),
                    min3           : v => (v !== undefined && v.length >= 3) || this.$t("rules.min-chars", {n: 3}),
                    max30          : v => (v !== undefined && v.length <= 30) || this.$t("rules.max-chars", {n: 30}),
                    max150         : v => (v !== undefined && v.length <= 150) || this.$t("rules.max-chars", {n: 150}),
                    no_white_spaces: v => (v !== undefined && !(v.indexOf(" ") >= 0)) || this.$t("rules.no-spaces-allowed"),
                    valid_email    : v => (v !== undefined && /.+@.+\..+/.test(v)) || this.$t("rules.email-must-valid"),
                }
            }
        },
        watch  : {
            dialog() {
                this.reset_captcha();
            },
        },
        methods: {
            on_captcha_verified(token) {
                this.captcha_success = true;
                this.captcha_token   = token;
            },
            reset_captcha_state() {
                this.captcha_success = false;
                this.captcha_token   = "";
            },
            // A captcha token can only be used once, so the captcha is rendered again after every attempt
            reset_captcha() {
                this.reset_captcha_state();
                this.unlock_captcha++;
            },
            async request_new_password() {
                if (this.$refs.r_form_reset_password.validate()
                    && this.email.trim().length > 0
                    && this.username.trim().length > 0
                    && this.$root.check_captcha(this.captcha_success)) {
                    let response = await this.func.ax("/php/request_new_password.php", {
                        language: this.$lang,
                        email   : this.email,
                        username: this.username,
                        captcha : this.captcha_token,
                    });
                    this.reset_captcha();
                    await this.$root.check_response(response, () => {
                        this.dialog = false;
                        this.eventbus.$emit("SB", "login-register-account.reset-password.msg.success", "success", 10);
                    }, "login-register-account.reset-password.msg.error");
                }
                this.email    = "";
                this.username = "";
                this.unlock_request_password++;
            },
        },
    }
</script>